// extracted by mini-css-extract-plugin
export default {"wrapper":"Credits_wrapper__ujkIj","credits":"Credits_credits__W8DBq","box":"Credits_box__hcUm6","value":"Credits_value__dVbPa"};